/* eslint-disable func-names */
/* eslint-disable class-methods-use-this */
const $ = window.jQuery;

class SchemaFaq {
  constructor() {
    window.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    this.initFAQ();
  }

  initFAQ() {
    $('.schema-faq-question').click(function() {
      // Toggle the visibility of the answer for the clicked question
      $(this)
        .next('.schema-faq-answer')
        .slideToggle();
      // Toggle active class
      $(this).toggleClass('active');
      // Hide other answers
      $('.schema-faq-answer')
        .not($(this).next('.schema-faq-answer'))
        .slideUp();
      // Remove active class from other questions
      $('.schema-faq-question')
        .not($(this))
        .removeClass('active');
    });
  }
}

export default new SchemaFaq();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/schema-faq.js